<template>
  <div v-loading="loading">
    <el-table
      :data="desadvs.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @row-click="(row) => $router.replace('/sales/desadvs/view/' + row.id)"
    >
      <el-table-column
        prop="id"
        label="#"
        width="80"
      />
      <el-table-column
        prop="customer_order_receipt_number"
        label="Vevői megrendelés"
      />
      <el-table-column label="Bizonylatszám">
        <template slot-scope="scope">
          {{ scope.row.despatch_advice_numbers || '—' }}
        </template>
      </el-table-column>
      <el-table-column
        label="Szállítás dátuma"
        width="190"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.shipment_delivery_dates">
            {{ scope.row.shipment_delivery_dates }}
          </span>
          <span
            v-else-if="scope.row.customer_order_delivery_date"
            class="order-date"
          >
            {{ scope.row.customer_order_delivery_date }}
          </span>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Raklapok"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.pallet_count }}
        </template>
      </el-table-column>
      <el-table-column
        label="Státusz"
        width="150"
      >
        <template slot-scope="scope">
          <el-tag
            size="small"
            :type="statusType(scope.row.status)"
          >
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="creator_user_name"
        label="Rögzítő"
      />
      <el-table-column
        label="Rögzítve"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.created_at ? scope.row.created_at.substr(0, 10) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="60"
      >
        <template slot-scope="scope">
          <Actions :desadv="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="desadvs.meta"
      class="el-card-footer"
    >
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-size="desadvs.meta.per_page"
        layout="total, prev, pager, next"
        :total="desadvs.meta.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';

export default {
  components: {
    Actions,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    desadvs() {
      return this.$store.getters['desadv/desadvs'];
    },
    loading() {
      return this.$store.getters['desadv/loading'];
    },
  },
  async mounted() {
    this.$store.commit('desadv/setFilterString', '');
    this.$store.commit('desadv/setCurrentPage', this.currentPage);
    await this.$store.dispatch('desadv/fetchAll');
  },
  methods: {
    statusLabel(status) {
      const labels = {
        open: 'Nyitott',
        finalized: 'Véglegesítve',
        partially_shipped: 'Részben szállítva',
        shipped: 'Szállítva',
      };
      return labels[status] || status;
    },
    statusType(status) {
      const types = {
        open: 'info',
        finalized: '',
        partially_shipped: 'warning',
        shipped: 'success',
      };
      return types[status] != null ? types[status] : 'info';
    },
    handleCurrentChange(val) {
      this.$store.commit('desadv/setCurrentPage', val);
      this.$store.dispatch('desadv/fetchAll');
    },
  },
};
</script>
<style scoped>
  .pointer-row {
    cursor: pointer;
  }
  .order-date {
    color: #909399;
  }
</style>
